/**
 * Help to prevent the default behavior of links, allowing only left clicks and skipping external targets or modifiers keys
 * @param evt Click event to be prevented
 * @returns a boolean to know if the event was prevented or not
 */
// Code Snippet extracted and modified from https://github.com/remix-run/react-router/blob/v5.3.3/packages/react-router-dom/modules/Link.js#L44
export const preventDefaultLinkEvent = (
  evt: MouseEvent | React.MouseEvent
): boolean => {
  // onClick already default prevented
  if (!evt || evt.defaultPrevented) {
    return true;
  }

  const anchorTarget = evt.target as HTMLAnchorElement;

  if (
    evt.button === 0 && // ignore everything but left clicks
    (!anchorTarget?.target || anchorTarget.target === '_self') && // let browser handle "target=_blank" etc.
    !(evt.metaKey || evt.altKey || evt.ctrlKey || evt.shiftKey) // ignore clicks with modifier keys
  ) {
    evt.preventDefault();
    evt.stopPropagation();
    return true;
  }

  return false;
};
